// Invite endpoint bindings (mirrors backend /invites/*). Used by the
// /invite/:token redemption page — the primary surface for the one-time
// invite links an admin emails to testers.
import { api } from "./client";

export interface InviteRedeemResponse {
  account_tier: string;
}

export function redeemInvite(token: string): Promise<InviteRedeemResponse> {
  return api.post<InviteRedeemResponse>(
    `/invites/${encodeURIComponent(token)}/redeem`,
  );
}
